import { Alert, Box, Typography } from '@mui/material';
import { useSyncExternalStore } from 'react';
import { Title } from 'react-admin';
import {
  getRetiredIntakePurgeStatus,
  subscribeRetiredIntakePurge,
} from '../../utils/retired-intake-purge';

/**
 * Fail-closed boundary retained for old bookmarks and direct URLs.
 *
 * The former browser handoff used a participant-held Intake capability. It
 * cannot be reclassified as Cadre capture without a server-authenticated
 * recorder contract, so this route intentionally exposes no session, cache,
 * form, recovery, queue, or transport behavior.
 */
export function IntakeSupervisorPage() {
  const purge = useSyncExternalStore(
    subscribeRetiredIntakePurge,
    getRetiredIntakePurgeStatus,
    getRetiredIntakePurgeStatus,
  );
  return <Box>
    <Title title="Sequential Intake Unavailable" />
    <Typography component="h1" variant="h5">Sequential intake unavailable</Typography>
    <Alert severity="warning">
      The former participant entry workflow has been withdrawn. No intake session can be started, resumed, viewed, or submitted from this portal route.
    </Alert>
    {purge.state !== 'complete' && <Alert severity="error">
      Retired intake storage removal is {purge.state}. Individual data remains unavailable. Close other CHAMBER tabs and reload; contact the Tenant administrator if this continues.
    </Alert>}
  </Box>;
}
